<template>
  <v-container class="container">
    <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div v-if="!isLoading">
      <v-row>
        <v-col class="pb-5">
          <span class="header bold text-tcdc-green">{{ form ? form[`name_${lang}`]:''}}</span>
        </v-col>
      </v-row>
      <v-layout justify-space-between>
        <v-flex>
          <div class="d-flex flex-1 align-center">
            <div class="pr-3 d-flex align-center">
              <img src="../../assets/icons/sorts/calendar.png" class="eventdetail-card-logo mr-4" />
              <span class="bold text-uppercase text-tcdc-green">{{form ? form.start_date+' - '+form.end_date : ''}}</span>
            </div>
            <div class="d-flex align-center">
              <img src="../../assets/icons/marker.png" class="eventdetail-card-logo mr-4" />
              <span class="bold text-uppercase text-tcdc-green">{{form ? form[`location_name_${lang}`] : ''}}</span>
            </div>
          </div>
        </v-flex>
        <v-flex shrink>
          <ShareButton mode="program"></ShareButton>
        </v-flex>
      </v-layout>
      <v-row v-if="form">
        <v-col>
          <!-- desktop -->
          <v-img class="hidden-sm-and-down" v-if="form.img_cover_desktop" :src="form.img_cover_desktop" aspect-ratio="2.8"></v-img>
          <v-img class="hidden-sm-and-down" v-else :src="require('../../assets/uploadImage.jpg')" aspect-ratio="2.8"></v-img>
          <!-- mobile -->
          <v-img class="hidden-md-and-up" v-if="form.img_cover_mobile" :src="form.img_cover_mobile" aspect-ratio="1"></v-img>
          <v-img class="hidden-md-and-up" v-else :src="require('../../assets/uploadImage.jpg')" aspect-ratio="1"></v-img>
        </v-col>
      </v-row>
      <v-col align="center" style="padding: 20px">
        <GreenButton :label="form[`button_name_${lang}`] ? form[`button_name_${lang}`]:$t('event.more')" :height="height" :width="width"
                     @click.native="goToRegister(form.url)"
                     v-if="form && form.url"/>
      </v-col>
      <v-row class="pb-8">
        <v-col>
        <span class="vhtml" v-html="form ? form[`detail_${lang}`] : ''">
        </span>
        </v-col>
      </v-row>
      <v-col align="center">
        <GreenButton :label="form[`button_name_${lang}`] ? form[`button_name_${lang}`]:$t('event.more')" :height="height" :width="width"
                     @click.native="goToRegister(form.url)"
                     v-if="form && form.url"/>
      </v-col>
      <div v-if="relatedItem.length > 0">
        <v-row class="pt-8">
          <v-col>
            <span class="text-tcdc-green header bold text-uppercase">{{$t('event.related')}}</span>
          </v-col>
        </v-row>
        <v-row class="d-flex flex-wrap" v-if="relatedItem.length > 0">
          <template v-for="(item, index) of relatedItem">
            <v-col cols="12" md="6" :key="index">
              <EventCard
                      class="cursor-pointer"
                      :name="item[`name_${lang}`]"
                      :time_start="item.start_date"
                      :time_end="item.end_date"
                      :place="item.location_name"
                      :img="$vuetify.breakpoint.smAndDown ? item.img_cover_mobile : item.img_cover_desktop"
                      @click.native="eventDetailHandler(item.product_id)"
              />
            </v-col>
          </template>
        </v-row>
        <v-row v-else class="grey--text mt-3 px-2">
          <v-col>
            {{$t('event.no-related')}}
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import EventCard from "../../components/cards/EventCard";
import {mapState} from "vuex";
import GreenButton from "../../components/buttons/GreenButton";
import ShareButton from "../../components/buttons/ShareButton";
import Loading from 'vue-loading-overlay';

export default {
  components: {
    GreenButton,
    EventCard,
    ShareButton,
    Loading
  },
  metaInfo() {
    return {
      meta: [
        { charset: 'utf-8' },
        {
          property: 'og:image',
          content: this.form.img_cover_desktop,
          vmid: 'og:image'
        }
      ]
    }
  },
  computed:{
    ...mapState({
      form : state=>{
        return state.Program.form;
      },
      branchName : state=>{
        return state.Branch.branch_name;
      },
      lang : state=>{
        return state.Branch.lang;
      }
    }),
    branchChanged: function() {
      return this.branchName;
    },
    routeId: function () {
      return this.$route.params.id;
    }
  },
  watch: {
    branchChanged: function() {
      this.items[0].text = this.branchChanged;
    },
    routeId: async function () {
      await this.$store.dispatch("Program/getProgramEventById",{
        id: this.$route.params.id,
        lang: this.lang,
      });
      this.relatedItem = await this.$store.dispatch("Program/onGetRelatedEventById", this.$route.params.id);
    }
  },
  async created() {
    this.setItemBranch();
    this.isLoading = true;
    await this.$store.dispatch("Program/getProgramEventById",{
      id: this.$route.params.id,
      lang: this.lang,
    });
    this.relatedItem = await this.$store.dispatch("Program/onGetRelatedEventById", this.$route.params.id);
    this.isLoading = false;
  },
  methods: {
    eventDetailHandler(id) {
      this.$router.push(`/events/${id}`);
    },
    setItemBranch(){
      if(this.branchName){
        this.items[0].text = this.branchName;
      }
    },
    goToRegister(url){
      if(url){
        window.open(url,'_blank')
      }
    }
  },
  data: () => ({
    height : '45px',
    width : '150px',
    isLoading: false,
    items: [
      {
        text: 'TCDC BANGKOK',
        disabled: true,
        to: "/home"
      },
      {
        text: "PROGRAM",
        disabled: false,
        to: "/home"
      }
    ],
    events: [
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      },
      {
        name: "master of materials",
        time: "14 Aug - 13 Oct 2019",
        place: "TCDC Bangkok",
        highlight: false
      }
      // 4 และ highlight
    ],
    relatedItem: []
  })
};
</script>

<style scoped>
.eventdetail-card-logo {
  height: 25px;
  object-fit: contain;
}
</style>
